import {
    TrueBase,
    css,
    html
} from "../TrueBase/TrueBase";

/**
 * @customelement - true-text-image
 * @description
 * A component that has text and image for content.
 *
 * ### Properties
 *
 *
 */
export class TrueTextImage extends TrueBase {
    static get properties() {
        return {
            verticalCenterText: {
                type: Boolean
            }
        }
    }

    constructor() {
        super();
    }

    render() {
        return html `
    <div class="text">
        <div class="text-content">
            <slot name="text"></slot>
        </div>
    </div>
    <div class="image">
        <slot name="image"></slot>
    </div>
`
    }

    static get styles() {
        return css `
            :host {
                display: flex;
                flex-direction: var(--text-image-flex-direction, row);
                position: relative;
                overflow: var(--text-image-overflow, visible);
            }

            :host([verticalCenterText]) .text {
                display: flex;
                align-items: center;
            }

            .text {
                position: relative;
                z-index: 2;
                max-width: var(--text-image-max-width, 70%);
            }

            .text,
            .image {
                flex: 1 1 50%;
                height: var(--text-image-height, 550px);
            }

            .image {
                position: var(--text-image-position, absolute);
                right: var(--text-image-position-right, 0);
                left: var(--text-image-position-left, auto);
                z-index: var(--text-image-z-index, 1);
                width: var(--text-image-width, 50%)
            }

            .text-content {
                color: var(--text-image-text-color, black);
                mix-blend-mode: difference;
                margin: var(--text-image-text-margin, 0);
            }

        `;
    }
}

window.customElements.get("true-text-image") || window.customElements.define('true-text-image', TrueTextImage);